import { motion } from "framer-motion";
import { ShieldCheck, Download, Lock } from "lucide-react";

const METHODS = ["VISA", "Mastercard", "AMEX", "PayPal", "Apple Pay", "Google Pay"];

export const TrustStrip = () => (
  <section className="relative border-y border-white/10 bg-void-soft/60 py-12" data-testid="trust-payment-strip">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="flex flex-col lg:flex-row items-center justify-between gap-8"
      >
        <div className="flex items-center gap-3">
          <ShieldCheck className="w-6 h-6 text-white" />
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">
            Bezahle, wie du willst
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-2.5">
          {METHODS.map((m) => (
            <span
              key={m}
              className="px-4 py-2 rounded-md border border-white/10 bg-white/5 font-mono text-xs tracking-wider text-slate-200"
            >
              {m}
            </span>
          ))}
        </div>
        <div className="flex items-center gap-6 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
          <span className="flex items-center gap-2">
            <Lock className="w-3.5 h-3.5" /> 256-Bit SSL
          </span>
          <span className="flex items-center gap-2">
            <Download className="w-3.5 h-3.5" /> Sofort-Download per E-Mail
          </span>
        </div>
      </motion.div>
    </div>
  </section>
);
